import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FrontLayoutComponent } from './front-layout.component';
import { UpcomingEventsComponent } from './upcoming-events/upcoming-events.component';
import { AcademyComponent } from './academy/academy.component';
import { UAEComponent } from './uae/uae.component';
import { GcseClassesComponent } from '../landingpages/gcse-classes/gcse-classes.component';
import { TimetableComponent } from '../calender/timetable/timetable.component';
import { GcsetimetableComponent } from '../calender/gcsetimetable/gcsetimetable.component';

import { TopicTestComponent } from '../calender/topic-test/topic-test.component';
import { WebinarComponent } from './webinar/webinar.component';
import { ElevplusClassesComponent } from '../landingpages/elevplus-classes/elevplus-classes.component';
import { ProductServicesComponent } from '../landingpages/product-services/product-services.component';
import { ConsortiumComponent } from './consortiums/consortium/consortium.component';
import { PageOneComponent } from './consortiums/page-one/page-one.component';
import { PageCsseComponent } from './consortiums/page-csse/page-csse.component';
import { PageRedbridgeComponent } from './consortiums/page-redbridge/page-redbridge.component';
import { PageBucksComponent } from './consortiums/page-bucks/page-bucks.component';
import { PageW11plusComponent } from './consortiums/page-w11plus/page-w11plus.component';
import { GrammarSchoolsComponent } from './consortiums/grammar-schools/grammar-schools.component';
import { ElevPlusTestsComponent } from './calendar/elev-plus-tests/elev-plus-tests.component';
import { GcseTestsComponent } from './calendar/gcse-tests/gcse-tests.component';
import { PageHbsComponent } from './consortiums/page-hbs/page-hbs.component';
import { PageQeComponent } from './consortiums/page-qe/page-qe.component';
import { PageReadingComponent } from './consortiums/page-reading/page-reading.component';
import { PageSuttonComponent } from './consortiums/page-sutton/page-sutton.component';
import { PageSloughComponent } from './consortiums/page-slough/page-slough.component';
import { RapidCourseComponent } from './rapid-course/rapid-course.component';
import { PageBexleyComponent } from './consortiums/page-bexley/page-bexley.component';

import { CchsGirlsComponent } from './consortiums/cchs-girls/cchs-girls.component';
import { PageReadingBoysComponent } from './consortiums/page-reading-boys/page-reading-boys.component';
import { PageReadingGirlsComponent } from './consortiums/page-reading-girls/page-reading-girls.component';
import { PageFsceComponent } from './consortiums/page-fsce/page-fsce.component';
import { SatTestComponent } from './calendar/sat-test/sat-test.component';
import { CreativeWritingComponent } from './creative-writing/creative-writing.component';
import { SpagCourseComponent } from './spag-course/spag-course.component';
import { FreeResourseComponent } from './free-resourse/free-resourse.component';
import { PageTraffordComponent } from './consortiums/page-trafford/page-trafford.component';
import { AdmissionOpenComponent } from './admission-open/admission-open.component';
import { KeyDatesComponent } from './key-dates/key-dates.component';
import { LatymerComponent } from './consortiums/latymer/latymer.component';
import { BootcampComponent } from './bootcamp/bootcamp.component';
import { BridgeCourseComponent } from './bridge-course/bridge-course.component';
import { PythonCourseComponent } from './python-course/python-course.component';
import { EightWeekCombinedComponent } from './eight-week-combined/eight-week-combined.component';
import { QuestionBankComponent } from './question-bank/question-bank.component';
import { BlogsComponent } from './blogs/blogs.component';
import { BlogsReadComponent } from './blogs-read/blogs-read.component';
import { TestComponent } from './test/test.component';
import { DataScienceComponent } from './data-science/data-science.component';
import { ElevenPlusSprintComponent } from './eleven-plus-sprint/eleven-plus-sprint.component';
import { ElevenPlusCwComponent } from './eleven-plus-cw/eleven-plus-cw.component';
import { LocationsComponent } from './location/locations/locations.component';
import { LocationDetailsComponent } from './location/location-details/location-details.component';
import { GcseLocationDetailsComponent } from './location/gcse-location-details/gcse-location-details.component';
import { GcseLocationComponent } from './location/gcse-location/gcse-location.component';
import { ElevenTopicTestComponent } from './eleven-topic-test/eleven-topic-test.component';
import { ElevenplusHelpclubComponent } from './elevenplus-helpclub/elevenplus-helpclub.component';
import { GcseHelpClubComponent } from './gcse-help-club/gcse-help-club.component';
import { YearFourCalComponent } from './calendar/year-four-cal/year-four-cal.component';
import { YearTenMocktestComponent } from './calendar/year-ten-mocktest/year-ten-mocktest.component';
import { FreeAssessmentComponent } from './free-assessment/free-assessment.component';
import { ResourceDownloadComponent } from './resource-download/resource-download.component';
import { FsceComponent } from './fsce/fsce.component';
import { DigitalDownloadsComponent } from './digital-downloads/digital-downloads.component';
import { GeneralFaqComponent } from './FAQ/general-faq/general-faq.component';
import { ParentFaqComponent } from './FAQ/parent-faq/parent-faq.component';
import { PricingPageComponent } from './pricing-page/pricing-page.component';
import { PreAdmissionComponent } from './pre-admission/pre-admission.component';
import { DigitalDownloadDetailsComponent } from './digital-download-details/digital-download-details.component';
import { GcseBootcampComponent } from './gcse-bootcamp/gcse-bootcamp.component';
import { PrivateSchoolsComponent } from './private-schools/private-schools.component';
import { KsThreeMockTestComponent } from './calendar/ks-three-mock-test/ks-three-mock-test.component';
import { GcseAdmissionComponent } from './gcse-admission/gcse-admission.component';
import { ChelmsfordMockComponent } from './chelmsford-mock/chelmsford-mock.component';


//import { DataScienceComponent } from './data-science/data-science.component';

const routes: Routes = [
  {
    path: '', component: FrontLayoutComponent,
    children: [
      { path: 'sehyog', loadChildren: () => import('../front-layout/sehyog/sehyog.module').then(m => m.SehyogModule) },
      { path: '11plus-help-club', loadChildren: () => import('../front-layout/eleven-plus/eleven-plus.module').then(m => m.ElevenPlusModule) },
      { path: 'become-a-volunteer', loadChildren: () => import('../front-layout/become-volunteer/become-volunteer.module').then(m => m.BecomeVolunteerModule) },
      { path: 'donation', loadChildren: () => import('../front-layout/make-donation/make-donation.module').then(m => m.MakeDonationModule) },
      { path: 'freedemo', loadChildren: () => import('../front-layout/make-donation/make-donation.module').then(m => m.MakeDonationModule) },
      { path: 'request-for-franchise', loadChildren: () => import('../front-layout/request-franchise/request-franchise.module').then(m => m.RequestFranchiseModule) },
      { path: 'contact-us', loadChildren: () => import('../front-layout/contact-us/contact-us.module').then(m => m.ContactUsModule) },
      { path: 'basket', loadChildren: () => import('../front-layout/basket/basket.module').then(m => m.BasketModule)},
      { path: 'payment', loadChildren: () => import('../front-layout/payment/payment.module').then(m => m.PaymentModule)},
      { path: 'support', loadChildren: () => import('../front-layout/support/support.module').then(m => m.SupportModule) },
      { path: 'legal', loadChildren: () => import('../front-layout/legal/legal.module').then(m => m.LegalModule) },
      { path: '11plus-live' , component: UpcomingEventsComponent },
      { path: 'academy' , component: AcademyComponent },
      { path: 'UAE' , component: UAEComponent },
      { path: 'gcse-classes', component: GcseClassesComponent},

      { path: '11plus-mock-test', component: ElevPlusTestsComponent, data: { shouldDetach: false }},
      { path: 'gcse-mock-test', component: GcseTestsComponent},

      { path: 'topic-test', component: TopicTestComponent},
      { path: 'webinar', component: WebinarComponent},
      { path: '11Plus-classes', component: ElevplusClassesComponent},
      { path: 'product-services', component: ProductServicesComponent},
      { path: 'consortium', component: ConsortiumComponent},
      { path: 'kent', component: PageOneComponent},
      { path: 'csse-schools', component: PageCsseComponent},
      { path: 'redbridge-schools', component: PageRedbridgeComponent},
      { path: 'bucks-schools', component: PageBucksComponent},
      { path: 'w11plus', component: PageW11plusComponent},
      { path: 'grammar-schools', component: GrammarSchoolsComponent},

      // {path: 'elev-plus-tests', component: ElevPlusTestsComponent},
      // {path: 'gcse-tests', component: GcseTestsComponent},
      
      {path: 'hbs', component: PageHbsComponent},
      {path: 'qe', component: PageQeComponent},
      {path: 'reading', component: PageReadingComponent},
      {path: 'sutton', component: PageSuttonComponent},
      {path: 'slough', component: PageSloughComponent},
      {path: '11plus-summer-intensive', component: RapidCourseComponent},
      {path: 'bexley', component: PageBexleyComponent},
      
      {path: 'cchsgirls', component: CchsGirlsComponent},
      {path: 'readingboys', component: PageReadingBoysComponent},
      {path: 'readinggirls', component: PageReadingGirlsComponent},
      {path: 'fsce', component: PageFsceComponent},
      {path: 'trafford', component: PageTraffordComponent},
      {path: 'latymer', component: LatymerComponent},
      {path: '11plus-summer-bootcamp', component: BootcampComponent},
      {path: 'bridge-courses', component: BridgeCourseComponent},
      {path: 'python-course', component: PythonCourseComponent},
      {path: 'genAI-dataScience-program', component: EightWeekCombinedComponent},
      {path: 'question-bank', component: QuestionBankComponent},
      {path: 'blogs', component: BlogsComponent},
      { path: 'blogs/:slug', component: BlogsReadComponent },
      { path: 'tests', component: TestComponent },
      {path: '11plus-sprint', component: ElevenPlusSprintComponent},
      {path: '11plus-creative-writing', component: ElevenPlusCwComponent},
      {path: 'locations', component: LocationsComponent},
      {path: 'locations/:town', component: LocationDetailsComponent},

      {path: 'location', component: GcseLocationComponent},
      {path: 'location/:town', component: GcseLocationDetailsComponent},


      {path: 'sat-test', component: SatTestComponent},
      {path: 'creative-writing', component: CreativeWritingComponent},
      {path: 'spag-course', component: SpagCourseComponent},
      {path: 'offer-free-resources', component: FreeResourseComponent} ,
      {path: '11plus-admission', component: AdmissionOpenComponent},
      {path: 'key-dates', component: KeyDatesComponent},
      {path: 'data-science',component: DataScienceComponent},

      {path: '11plus-topic-test',component: ElevenTopicTestComponent},
      {path: '11plus-HelpClub',component: ElevenplusHelpclubComponent},
      {path: 'gcse-help-club', component: GcseHelpClubComponent },
      {path: 'year-4-mock-test', component: YearFourCalComponent},
      {path: 'year-10-mock-test', component: YearTenMocktestComponent},
      {path: 'free-assessment', component: FreeAssessmentComponent},
      {path: 'free-resources', component: ResourceDownloadComponent},
      {path: 'fsce-11-plus-exam-overview', component: FsceComponent},
      {path: 'digital-download', component: DigitalDownloadsComponent},
      {path: 'digital-download/:slug', component: DigitalDownloadDetailsComponent},
      {path: 'faq/general-faq', component: GeneralFaqComponent},
      {path: 'faq/parent-faq', component: ParentFaqComponent},
      {path: '11plus-course-pricing', component: PricingPageComponent},
      {path: '11plus-assessment', component: PreAdmissionComponent},
      {path: 'gcse-summer-bootcamp', component: GcseBootcampComponent},
      {path: 'private-schools', component: PrivateSchoolsComponent},
      {path: 'ks3-mock-test', component: KsThreeMockTestComponent},
      {path: 'gcse-admission', component: GcseAdmissionComponent},
      {path: '11plus-mocks-chelmsford', component: ChelmsfordMockComponent},

      
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FrontLayoutRoutingModule { }
